import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { UserShortInfo } from "../../types";
import ManShortSelector from "../../components/ui/shortItemSelect";
import {
  libBackend,
  backend,
  taskBackend,
  TaskCreationData,
} from "../../services";
import { RootState } from "../../state/reducer";
import { toast } from "sonner";
import DateInput from "../../components/ui/dateInput";

interface ModalLoaderProps {
  onSave: () => void;
  closeModal: () => void;
}

const CreateTaskModal: React.FC<ModalLoaderProps> = ({
  onSave,
  closeModal,
}) => {
  const State = useSelector((state: RootState) => state);
  const [usersToSelect, setUsersToSelect] = useState<UserShortInfo[]>([]);
  const groupList = State.groupsToSelect;
  const rights = State.rights;
  const [selectedGroup, setSelectedGroup] = useState<number>(
    rights.group_ids[0]
  );
  const [selectedUserId, setSelectedUser] = useState<number>();
  const [selectedCustomerId, setSelectedCustomer] = useState<number>();
  const [taskTypeList, setTaskTypeList] = useState<
    { id: number; name: string }[]
  >([]);
  const [comment, setComment] = useState<string | undefined>();
  const [formData, setFormData] = useState<TaskCreationData>({
    title: "",
  });

  const closeWithSave = async () => {
    await saveAction();
    onSave(); // Передаем новое фото в callback
    closeModal(); // Закрываем модальное окно
  };
  useEffect(() => {
    // Загрузка списка пользователей и клиентов
    backend
      .getAllUsersShorts({ group_id: selectedGroup })
      .then((res) => {
        setUsersToSelect(res.users);
      })
      .catch((e) => {
        toast("Не удалось загрузить данные");
      });
  }, [groupList, selectedGroup]);

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateSelect = (date: string) => {
    setFormData((prev) => ({ ...prev, ["date_end"]: date }));
  };

  const saveAction = async () => {
    console.log("Save action called");
    return new Promise((resolve) => {
      const dataToSave = {
        ...formData,
        executer_id: selectedUserId,
        date_end: formData.date_end
          ? new Date(formData.date_end).getTime()
          : undefined,
      };

      taskBackend
        .createTask(dataToSave)
        .then(() => {
          toast("Задача создана");
          resolve(true);
        })
        .catch(() => {
          toast("Ошибка создания задачи");
          resolve(false);
        });

      console.log("To save:", dataToSave);
    });
  };

  return (
    <div className="creationForm">
      <div className="modalHeading">
        <h3>Создание задачи</h3>
      </div>
      <form className="columnCenter">
        {/* Поле: Название задачи */}
        <div className="formField formRow">
          <label htmlFor="title">Название задачи:</label>
          <input
            type="text"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            style={{
              width: 256,
            }}
          />
        </div>

        {/* Поле: Дедлайн */}
        <div className="formField formRow dateInputSingle">
          <label htmlFor="date_end">Дата выполнения:</label>
          <DateInput
            value={formData.date_end || ""}
            onSelect={handleDateSelect}
            onlyFuture={true}
          />
        </div>

        <div className="flex formRow">
          <div className="fieldName">Группа</div>
          <div className="fieldInput flex">
            <select
              id="group_id"
              name="group_id"
              value={selectedGroup}
              onChange={(event) => {
                const group = Number(event.target.value);
                backend.getAllUsersShorts({ group_id: group }).then((res) => {
                  setUsersToSelect(res.users);
                });
                setSelectedGroup(group);
              }}
            >
              <option value="0">Любая</option>
              {groupList.map((item, index) => {
                return (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        {/* Поле: Ответственный */}
        <div className="formField formRow">
          <label>Ответственный:</label>
          <ManShortSelector
            items={usersToSelect}
            onChangeCallback={(id) => setSelectedUser(id)}
          />
        </div>

        {/* Кнопки действий */}
        <div className="flex between btnRow">
          <button
            className="filterButton"
            type="button"
            onClick={closeWithSave}
          >
            Сохранить
          </button>
          <button className="cancelButton" type="button" onClick={closeModal}>
            Отменить
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateTaskModal;
